export default "__VITE_ASSET__f68088dc__"